import React from 'react'
import PropTypes from 'prop-types'

import user from 'assets/images/blank-user.png'

import Moment from 'moment'
import Styles from './index.scss'

const ChatWork = props => (
  <div className={`${Styles.container}`}>
    <img src={user} alt="Avatar" style={{ width: '100%' }} />
    <div>
      {
        props.row.type === 'chat'
        ? <div dangerouslySetInnerHTML={{ __html: props.row.say }} />
        : <div><p>{props.row.work.caption}</p></div>
      }
    </div>
    <div className="col-xs-12">
      <span className={`${Styles['time-right']}`}>
        {props.row.user.firstName} - {props.row.profile.name} {Moment(`${props.row.createdAt}`).format('DD MMMM YYYY - h:mm:ss a')}
      </span>
      {
        props.row.type === 'work'
        ? <span className={`${Styles['time-left']}`}>
          <i>There is a file uploaded</i>
        </span>
        : ''
      }
    </div>
  </div>
)

ChatWork.propTypes = {
  row: PropTypes.shape({
    say: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    work: PropTypes.shape({
      caption: PropTypes.string.isRequired,
    }).isRequired,
    user: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
    }).isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
}

export default ChatWork
